module.exports = ".mat-card {\n  width: 20%;\n  text-align: center;\n  margin: 20px auto; }\n\n.spinner {\n  margin: 0 auto; }\n"